module.exports = __webpack_public_path__ + "img/bin.90cc9cfb.png";